<template>
  <div>
    <div class="left-container">
      <application-list @selected="selected" />
    </div>
    <div class="right-container">
      <application-detail :app-key="appKey" />
    </div>
  </div>
</template>

<script>
import ApplicationDetail from '@/pages/tools/application/components/ApplicationDetail';
import ApplicationList from '@/pages/tools/application/components/ApplicationList';
export default {
  components: { ApplicationDetail, ApplicationList },
  data() {
    return {
      appKey: this.$route.query.appKey || null
    };
  },
  watch: {
    $route() {
      this.appKey = this.$route.query.appKey || null;
    }
  },
  methods: {
    selected(value) {
      this.$router.push({ name: 'page:tool:application', query: { appKey: value }});
    }
  }
};
</script>
<style lang="less" scoped>
.left-container {
  width: 200px;
  float: left;
  margin-right: 16px;
}
.right-container {
  width: calc(~'100% - 216px');
  height: calc(~'100vh - 138px');
  overflow: auto;
  float: left;
}
</style>
